module.exports = {
      id: "comm-entertainment-usage",
      viewBox: "0 0 269.757 51.703",
      url: "/" + "sprite-ab56b996b385d9abaaf31e01c38c81cd.svg#comm-entertainment",
      toString: function () {
        return this.url;
      }
    }